import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { PlatformComponent } from "@components/platform/platform.component";
import { CatalogsComponent } from "@components/platform/catalogs.component";
import { CatalogsListComponent } from "@components/platform/catalogs.list.component";
import { CatalogsCreateComponent } from "@components/platform/catalogs.create.component";
import { SettingsComponent } from "@components/platform/settings.component";
import { SwitchToBetaComponent } from "@components/switch-to-beta.component";
import { PageNotFoundComponent } from "@components/misc/page-not-found.component";
import { ProductsComponent } from "@app/components/platform/products.component";
import { ExpirationGuardService } from "@app/services/expiration-guard.service";
// import { GifMakerGuardService } from "@app/services/gif-maker-guard.service";
import { CatalogsInstallComponent } from "@app/components/platform/catalogs.install.component";
import { SessionGuardService } from "@app/services/session-guard.service";
import { WelcomeComponent } from "@app/components/platform/welcome.component";
import { WelcomeGuardService } from "@app/services/welcome-guard.service";
import { RootGuardService } from "@app/services/root-guard.service";
import { LoadingComponent } from "@app/components/loading.component";
import { TearSheetComponent } from "@app/components/platform/tear-sheet.component";
import { FeatureRequestsComponent } from "@app/components/platform/feature-requests.component";
import { TearSheetGuardService } from "@app/services/tear-sheet-guard.service";
import { OrderSheetGuardService } from "@app/services/order-sheet-guard.service";
import { OrderSheetComponent } from "@app/components/platform/order-sheet.component";
import { RequestInviteComponent } from "@app/components/platform/request-invite.component";
import { DigitalOrderSheetComponent } from "@app/components/platform/digital-order-sheet.component";
import { CompleteOrderComponent } from "@app/components/platform/complete-order.component";
import { ShoppingCartComponent } from "@app/components/platform/shopping-cart.component";
import { DigitalOrderSheetViewComponent } from "@app/components/platform/digital-order-sheet.view.component";
import { OrderSheetsComponent } from "@app/components/platform/order-sheets.component";
import { OrderSheetsListComponent } from "@app/components/platform/order-sheets.list.component";
import { CatalogOrderSheetDownloadComponent } from "@app/components/platform/catalog-order-sheet.download.component";
import { BarcodeComponent } from "@app/components/platform/barcode.component";
import { TutorialVideosComponent } from "@app/components/platform/tutorial-videos.component";
import { PlaygroundComponent } from "@app/components/platform/playground.component";
import { InventoryComponent } from "@app/components/platform/inventory.component";
import { BulkImportComponent } from "@app/components/platform/bulk-import.component";
import { InventoryListComponent } from "@app/components/platform/inventory-list.component";
import { DigitalOrderSheetConfigurationComponent } from "@app/components/platform/digital-order-sheet-configuration.component";
import { InventoryTagComponent } from "@app/components/platform/inventory-tag.component";
import { FlipbookComponent } from "@app/components/platform/flipbook.component";
import { HomeComponent } from "@app/components/platform/home.component";
import { CatalogOrderSheetViewComponent } from "@app/components/platform/catalog-order-sheet.view.component";
import { DashboardComponent } from "@app/components/platform/dashboard.component";
import { UpgradeComponent } from "@app/components/platform/upgrade.component";
import { CatalogAddComponent } from "@app/components/platform/catalog-add.component";
import { CatalogTemplateComponent } from "@app/components/theme-creator/catalog-template.component";
import { ThemeEditorPanelComponent } from "@app/components/catalog-editor/theme-editor-panel.component";
import { BrandEditorPanelComponent } from "@app/components/catalog-editor/brand-editor-panel.component";
import { SVGEditorPanelComponent } from "@app/components/catalog-editor/svg-editor-panel.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full",
  },
  {
    path: "",
    children: [
      {
        path: "",
        canActivate: [ExpirationGuardService],
        component: DigitalOrderSheetComponent,
        data: { state: "digital-order-sheet" },
        children: [
          {
            path: "brand-editor-panel",
            component: BrandEditorPanelComponent,
          },
          {
            path: "theme-editor-panel",
            component: ThemeEditorPanelComponent,
          },
          {
            path: "svg-editor-panel",
            component: SVGEditorPanelComponent,
          },
          {
            path: "catalogs/:id/order-sheet/view",
            component: CatalogOrderSheetViewComponent,
            data: {
              state: "digital-order-sheet-catalog-view",
              source: "catalog",
            },
          },
          {
            path: "catalogs/:id/order-sheet/complete-order",
            component: CompleteOrderComponent,
            data: { state: "catalog-complete-order", source: "catalog" },
          },
          {
            path: "catalogs/:id/order-sheet/shopping-cart",
            component: ShoppingCartComponent,
            data: { state: "catalog-shopping-cart", source: "catalog" },
          },
          {
            path: "digital-order-sheets/:id/view",
            canActivate: [],
            component: DigitalOrderSheetViewComponent,
            data: { state: "digital-order-sheet-view", source: "online store" },
          },
          {
            path: "digital-order-sheets/:id/complete-order",
            component: CompleteOrderComponent,
            data: {
              state: "digital-order-sheet-complete-order",
              source: "online store",
            },
          },
          {
            path: "digital-order-sheets/:id/shopping-cart",
            component: ShoppingCartComponent,
            data: {
              state: "digital-order-sheet-shopping-cart",
              source: "online store",
            },
          },
        ],
      },
      {
        path: "catalogs/add",

        component: CatalogAddComponent,
        data: { state: "catalogs-add" },
      },
      {
        path: "",
        component: PlatformComponent,
        children: [
          {
            path: "plan-expired",
            component: UpgradeComponent,
          },
          // {
          //   path: "home",
          //   redirectTo: "/home",
          //   data: { state: "home" },
          // },
          {
            path: "home",
            component: DashboardComponent,
            canActivate: [ExpirationGuardService, WelcomeGuardService],
            data: { state: "home" },
          },
          {
            path: "dashboard",
            redirectTo: "/home",
            data: { state: "dashboard" },
          },
          // {
          //   path: "dashboard/:catalogId",
          //   component: DashboardComponent,
          //   canActivate: [ExpirationGuardService, WelcomeGuardService],
          //   data: { state: "dashboard-catalog" },
          // },
          {
            path: "templates",

            component: CatalogTemplateComponent,
            data: { state: "catalogs-templates" },
          },
          {
            path: "catalogs",
            component: CatalogsComponent,
            canActivate: [
              ExpirationGuardService,
              SessionGuardService,
              WelcomeGuardService,
            ],
            data: { state: "catalogs" },
            children: [
              {
                path: "list",

                component: CatalogsListComponent,
                data: { state: "catalogs-list" },
              },
              {
                path: "create",

                component: CatalogsCreateComponent,
                data: { state: "catalogs-create" },
              },
              {
                path: "install",
                component: CatalogsInstallComponent,
                data: { state: "catalogs-install" },
              },
            ],
          },
          {
            path: "order-sheets",
            component: OrderSheetsComponent,
            canActivate: [ExpirationGuardService, WelcomeGuardService],
            data: { state: "order-sheets" },
            children: [
              {
                path: "list",
                component: OrderSheetsListComponent,
                data: { state: "order-sheets-list" },
              },
              {
                path: "catalogs/:id",
                component: CatalogOrderSheetDownloadComponent,
                data: { state: "catalog-order-sheet-download" },
              },
            ],
          },
          {
            path: "tear-sheet",
            component: TearSheetComponent,
            canActivate: [
              ExpirationGuardService,
              SessionGuardService,
              TearSheetGuardService,
            ],
            data: { state: "tear-sheet" },
          },
          {
            path: "barcode",
            component: BarcodeComponent,
            canActivate: [ExpirationGuardService, SessionGuardService],
            data: { state: "barcode" },
          },
          {
            path: "inventory-tag",
            component: InventoryTagComponent,
            canActivate: [ExpirationGuardService, SessionGuardService],
            data: { state: "inventory-tag" },
          },
          {
            path: "order-sheet",
            component: OrderSheetComponent,
            canActivate: [
              ExpirationGuardService,
              SessionGuardService,
              OrderSheetGuardService,
            ],
            data: { state: "order-sheet" },
          },
          {
            path: "feature-requests",
            canActivate: [SessionGuardService],
            component: FeatureRequestsComponent,
            data: { state: "feature-requests" },
          },
          {
            path: "tutorial-videos",
            canActivate: [SessionGuardService],
            component: TutorialVideosComponent,
            data: { state: "tutorial-videos" },
          },
          {
            path: "settings",
            canActivate: [SessionGuardService],
            component: SettingsComponent,
            data: { state: "settings" },
          },
          {
            path: "products",
            canActivate: [SessionGuardService],
            component: ProductsComponent,
            data: { state: "products" },
          },
          {
            path: "playground",
            canActivate: [SessionGuardService],
            component: PlaygroundComponent,
            data: { state: "playground" },
          },
          {
            path: "inventory",
            canActivate: [SessionGuardService],
            component: InventoryComponent,
            data: { state: "inventory" },
            children: [
              {
                path: "list",
                canActivate: [SessionGuardService],
                component: InventoryListComponent,
                data: { state: "inventory-list" },
              },
              {
                path: "bulk-import",
                canActivate: [SessionGuardService],
                component: BulkImportComponent,
                data: { state: "bulk-import" },
              },
            ],
          },
          {
            path: "digital-order-sheet/configuration",
            canActivate: [SessionGuardService],
            component: DigitalOrderSheetConfigurationComponent,
            data: { state: "digital-order-sheet-configuration" },
          },
          {
            path: "flipbook",
            canActivate: [ExpirationGuardService, SessionGuardService],
            component: FlipbookComponent,
            data: { state: "flipbook" },
          },
          {
            path: "request-invite/:tool",
            canActivate: [SessionGuardService],
            component: RequestInviteComponent,
            data: { state: "request-invite" },
          },
        ],
      },
      {
        path: "switch-to-beta",
        canActivate: [SessionGuardService],
        component: SwitchToBetaComponent,
        data: { state: "switch-to-beta" },
      },
      {
        path: "welcome",
        canActivate: [SessionGuardService],
        component: WelcomeComponent,
        data: { state: "welcome" },
      },
    ],
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
